export default {
  msgOnDisconnect: "",
  connectedGuiches: []
};
